import React from 'react';
import Button from '@/components/ui/Button';
import BaseModal from './BaseModal';
import {InfoModalProps} from './types';
import i18n from 'i18n';

const InfoModal: React.FC<InfoModalProps> = ({
    isOpen,
    onClose,
    title,
    content,
    showCloseFooter = true,
    size = 'lg',
    centered = true,
    backdrop = 'static',
    className = '',
    hideCloseButton = false,
}) => {
    const footer = showCloseFooter ? (
        <Button variant="secondary" onClick={onClose} data-cy="info-undefined-return-btn">
            {i18n.t('jt_close.text') || 'Close'}
        </Button>
    ) : undefined;

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size={size}
            centered={centered}
            backdrop={backdrop}
            className={className}
            footer={footer}
            hideCloseButton={hideCloseButton}
        >
            {content}
        </BaseModal>
    );
};

export default InfoModal;
